import { useEffect, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import api from '../../api/axios';

export default function EmailTemplateForm({
  mode = 'create',
  mainCompanyId = 0,
  initial = null,
  onClose = () => {},
  onSaved = () => {},
}) {
  const [subject, setSubject] = useState(initial?.subject || '');
  const [content, setContent] = useState(initial?.content || '');
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  // update editor data if initial prop changes
  useEffect(() => {
    setSubject(initial?.subject || '');
    setContent(initial?.content || '');
  }, [initial]);

  const validate = () => {
    const errs = {};
    if (!subject || !subject.trim()) errs.subject = 'Subject is required';
    if (!content || !content.trim()) errs.content = 'Content is required';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (!validate()) return;
    setSaving(true);
    try {
      if (mode === 'create') {
        await api.post('/admin/email-templates', {
          main_company_id: mainCompanyId,
          subject: subject.trim(),
          content,
        });
      } else {
        await api.put(`/admin/email-templates/${initial.id}`, {
          subject: subject.trim(),
          content,
        });
      }
      onSaved();
    } catch (err) {
      console.error('Save failed', err?.response?.data || err?.message);
      const msg =
        err?.response?.data?.message ||
        err?.response?.data ||
        err?.message ||
        'Failed to save';
      setErrors({ form: msg });
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div>
        <label className="block text-sm">Subject</label>
        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          className="w-full border px-2 py-1 rounded"
        />
        {errors.subject && (
          <div className="text-red-600 text-xs">{errors.subject}</div>
        )}
      </div>

      <div>
        <label className="block text-sm">Content</label>
        <Editor
          value={content}
          onEditorChange={(newValue) => setContent(newValue)}
           apiKey="mpwzqoajpwgkybw09orm71pipq474ewfqapm6hde2mws0a0t"
          init={{
            height: 400,
            menubar: false,
            plugins: 'code',
            toolbar: 'undo redo | bold italic underline | code',
          }}
        />
        {errors.content && (
          <div className="text-red-600 text-xs">{errors.content}</div>
        )}
      </div>

      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onClose}
          className="px-3 py-1 border rounded"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={saving}
          className="px-3 py-1 bg-indigo-600 text-white rounded"
        >
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>

      {errors.form && (
        <div className="text-red-600 text-sm mt-2">{errors.form}</div>
      )}
    </form>
  );
}
